
import { CommentType, SortOption } from '@/components/reader-home/types';

export const filterCommentsByTopic = (comments: CommentType[], selectedTopics: string[]): CommentType[] => {
  if (selectedTopics.length === 0) return comments;
  
  return comments.filter(comment => {
    const commentHasSelectedTopic = comment.topics?.some(topic => 
      selectedTopics.includes(topic)
    ) || false;
    
    const repliesHaveSelectedTopic = comment.replies?.some(reply => 
      reply.topics?.some(topic => selectedTopics.includes(topic))
    ) || false;
    
    return commentHasSelectedTopic || repliesHaveSelectedTopic;
  });
};

export const sortComments = (comments: CommentType[], sortOption: SortOption): CommentType[] => {
  switch (sortOption) {
    case "newest":
      return [...comments].sort((a, b) => {
        if (a.timestamp.includes("Just now")) return -1;
        if (b.timestamp.includes("Just now")) return 1;
        if (a.timestamp.includes("hour") && b.timestamp.includes("day")) return -1;
        if (b.timestamp.includes("hour") && a.timestamp.includes("day")) return 1;
        return 0;
      });
    case "most-liked":
    case "mostLiked":
      return [...comments].sort((a, b) => b.likes - a.likes);
    case "highlighted":
      return [...comments].sort((a, b) => {
        if (a.highlighted && !b.highlighted) return -1;
        if (!a.highlighted && b.highlighted) return 1;
        return 0;
      });
    default:
      return comments;
  }
};

export const extractAllTopics = (comments: CommentType[]): string[] => {
  const topicsSet = new Set<string>();
  
  comments.forEach(comment => {
    (comment.topics || []).forEach(topic => topicsSet.add(topic));
    
    (comment.replies || []).forEach(reply => {
      (reply.topics || []).forEach(topic => topicsSet.add(topic));
    });
  });
  
  return Array.from(topicsSet).sort();
};

export const getFeaturedDiscussions = (comments: CommentType[]): CommentType[] => {
  return comments.filter(comment => 
    comment.highlighted || 
    comment.likes > 10 || 
    (comment.replies && comment.replies.length > 1)
  );
};
